import React, { useEffect, useState } from 'react'
import { SavedAudience } from '@marketing-milk/interfaces'
import { ViewAudienceModal } from '@marketing-milk/frontend'

/**
 * Full-targeting deep-dive for a single audience, reusing the app-wide
 * `ViewAudienceModal` (AudienceBreakdown: locations map, traits, usage, history)
 * rather than a packet-specific targeting viewer. It's only ever mounted with a
 * non-empty `audiences` array (AudienceBreakdown assumes `audiences[0]`), and
 * recalc is a no-op here — the packet never mutates audience size.
 *
 * `onModalOpenChange` lets Present lock deck Arrow/Esc navigation while the
 * dialog is open, mirroring the creative preview.
 */
export function useAudienceDetailModal(onModalOpenChange?: (open: boolean) => void) {
  const [detail, setDetail] = useState<SavedAudience | undefined>(undefined)
  const open = !!detail

  useEffect(() => {
    onModalOpenChange?.(open)
    return () => onModalOpenChange?.(false)
  }, [open, onModalOpenChange])

  const modals = detail ? (
    <ViewAudienceModal
      audiences={[detail]}
      showModal
      onHideModal={() => setDetail(undefined)}
      onRecalc={() => undefined}
      canRecalc={false}
    />
  ) : null

  return { onOpenDetail: setDetail, modals }
}
